import { render, staticRenderFns } from "./GdprConsent.vue?vue&type=template&id=501755a4&scoped=true&"
import script from "./GdprConsent.vue?vue&type=script&lang=js&"
export * from "./GdprConsent.vue?vue&type=script&lang=js&"
import style0 from "./GdprConsent.vue?vue&type=style&index=0&id=501755a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501755a4",
  null
  
)

export default component.exports